const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M51.0358 99.3405C77.9837 99.3405 99.8293 77.5387 99.8293 50.6449C99.8293 23.751 77.9837 1.94922 51.0358 1.94922C24.0878 1.94922 2.24219 23.751 2.24219 50.6449C2.24219 77.5387 24.0878 99.3405 51.0358 99.3405Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0_2634_62863)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.5 50.1098C100.5 52.9415 100.254 55.7062 99.7851 58.4041C97.5286 71.7598 89.9326 83.3317 79.2534 90.7787C75.7682 93.209 71.9701 95.2157 67.904 96.6873C62.5644 98.6717 56.778 99.7196 50.7682 99.7196C26.9522 99.7196 7.04608 82.9972 2.198 60.6561C1.46074 57.267 1.05859 53.7219 1.05859 50.0875C1.05859 22.7074 23.3106 0.5 50.7682 0.5C78.2257 0.5 100.5 22.7074 100.5 50.1098Z",
  fill: "url(#paint0_linear_2634_62863)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.0925 62.6189C94.0657 84.96 74.45 100.523 50.5447 100.523C24.0255 100.501 2.30965 79.9879 0.5 53.9678C8.45353 51.649 20.4508 51.6936 36.7154 65.1607C64.508 88.1484 94.5125 77.513 99.0925 62.5966V62.6189Z",
  fill: "#D6F5FF"
}));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M61.0478 83.2874C59.1711 83.9117 58.6573 84.4245 58.0317 86.2974C57.4062 84.4245 56.8923 83.9117 55.0156 83.2874C56.8923 82.6631 57.4062 82.1503 58.0317 80.2773C58.6573 82.1503 59.1711 82.6631 61.0478 83.2874Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M61.0478 83.2874C59.1711 83.9117 58.6573 84.4245 58.0317 86.2974C57.4062 84.4245 56.8923 83.9117 55.0156 83.2874C56.8923 82.6631 57.4062 82.1503 58.0317 80.2773C58.6573 82.1503 59.1711 82.6631 61.0478 83.2874Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.5 47C20.3222 47.7259 19.7259 48.3222 19 50.5C18.2741 48.3222 17.6778 47.7259 15.5 47C17.6778 46.2741 18.2741 45.6778 19 43.5C19.7259 45.6778 20.3222 46.2741 22.5 47Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M83.5 32C81.9444 32.5185 81.5185 32.9444 81 34.5C80.4815 32.9444 80.0556 32.5185 78.5 32C80.0556 31.4815 80.4815 31.0556 81 29.5C81.5185 31.0556 81.9444 31.4815 83.5 32Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d_2634_62863)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.5 71V22.5C70.5 21.3954 69.6046 20.5 68.5 20.5H50.5H40.5H38.9905C38.3664 20.5 37.778 20.7914 37.3997 21.2879L30.9091 29.8068C30.6437 30.1551 30.5 30.5809 30.5 31.0188V33.625V46.75V71C30.5 72.1046 31.3954 73 32.5 73H68.5C69.6046 73 70.5 72.1046 70.5 71Z",
  fill: "white"
}));

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5 33H38.5C39.6046 33 40.5 32.1046 40.5 31V20.5H38.9905C38.3664 20.5 37.778 20.7914 37.3997 21.2879L30.9091 29.8068C30.6437 30.1551 30.5 30.5809 30.5 31.0188V33Z",
  fill: "url(#paint1_linear_2634_62863)"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 45.5,
  y: 28,
  width: 20,
  height: 3,
  rx: 1,
  fill: "#009FEB"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 45.5,
  y: 35.5,
  width: 20,
  height: 3,
  rx: 1,
  fill: "#009FEB"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 35.5,
  y: 43,
  width: 30,
  height: 3,
  rx: 1,
  fill: "#CBF2FE"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 35.5,
  y: 50.5,
  width: 30,
  height: 3,
  rx: 1,
  fill: "#CBF2FE"
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 35.5,
  y: 58,
  width: 18.75,
  height: 3,
  rx: 1,
  fill: "#CBF2FE"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 68,
  y: 68.5,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#F9587A"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M89.8254 89.4904C89.9372 89.6012 90 89.7521 90 89.9096C90 90.067 89.9372 90.2179 89.8254 90.3288C89.714 90.4393 89.5632 90.5009 89.4064 90.5C89.2495 90.5009 89.0987 90.4393 88.9873 90.3288L84 85.3337L79.0127 90.3288C78.9013 90.4393 78.7505 90.5009 78.5936 90.5C78.4368 90.5009 78.286 90.4393 78.1746 90.3288C78.0628 90.2179 78 90.067 78 89.9096C78 89.7521 78.0628 89.6012 78.1746 89.4904L83.1678 84.5012L78.1746 79.5121C77.9431 79.2805 77.9431 78.9052 78.1746 78.6736C78.406 78.4421 78.7813 78.4421 79.0127 78.6736L84 83.6687L88.9873 78.6736C89.2187 78.4421 89.594 78.4421 89.8254 78.6736C90.0569 78.9052 90.0569 79.2805 89.8254 79.5121L84.8322 84.5012L89.8254 89.4904Z",
  fill: "white"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_2634_62863",
  x: 26.5,
  y: 18.5,
  width: 48,
  height: 60.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0.623529 0 0 0 0 0.921569 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2634_62863"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2634_62863",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2634_62863",
  x1: 39.7985,
  y1: 104.469,
  x2: 65.1473,
  y2: -21.5487,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#48D0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#94E4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#C3F0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#D6F5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2634_62863",
  x1: 35.5,
  y1: 28.625,
  x2: 41.125,
  y2: 34.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2FBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B5ECFF"
})));

const SvgProcessingQuestionError = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_62863",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 98,
    height: 99
  }, _ref2), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProcessingQuestionError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/processing-question-error.e02bef48.svg";
export { ForwardRef as ReactComponent };